module.exports = __webpack_public_path__ + "img/9.6e2f62d5.jpg";